import { branch, compose, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import MessageModal from '../components/MessageModal';
import { dismissMessage } from '../actions';
import { getActiveMessage, hasActiveMessage } from '../selectors';

const MessageModalContainer = compose(
  connect(
    state => ({
      hasActiveMessage: hasActiveMessage(state),
      ...getActiveMessage(state),
    }),
    { close: dismissMessage }
  ),
  branch(
    props => !props.hasActiveMessage,
    renderNothing,
  ),
)(MessageModal);

export default MessageModalContainer;
